import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

export interface Category {
  id: string;
  name: string;
  color: string;
  textColor: string;
}

interface CategoriesResponse {
  categories: Category[];
}

class UserService {
  async getCategories(): Promise<Category[]> {
    try {
      const response = await axios.get<CategoriesResponse>(`${API_BASE_URL}/users/categories`);
      return response.data.categories;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to fetch categories');
    }
  }

  async updateCategories(categories: Category[]): Promise<Category[]> {
    try {
      const response = await axios.put<CategoriesResponse>(`${API_BASE_URL}/users/categories`, {
        categories
      });
      return response.data.categories;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to update categories');
    }
  }

  async getProfile() {
    try {
      const response = await axios.get(`${API_BASE_URL}/users/profile`);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to fetch profile');
    }
  }

  async updateProfile(updates: any) {
    try {
      const response = await axios.patch(`${API_BASE_URL}/users/profile`, updates);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to update profile');
    }
  }

  async updatePreferences(preferences: any) {
    try {
      const response = await axios.patch(`${API_BASE_URL}/users/preferences`, preferences);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to update preferences');
    }
  }

  async changePassword(currentPassword: string, newPassword: string) {
    try {
      const response = await axios.patch(`${API_BASE_URL}/users/password`, {
        currentPassword,
        newPassword
      });
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to change password');
    }
  }
}

export const userService = new UserService();